import { BotPromptChannel } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

export interface LLMTestResult {
  response: string;
  toolCalls: { name: string; input: any; result: any }[];
  usage: { inputTokens: number; outputTokens: number };
  systemPrompt: { staticContent: string; dynamicContent: string };
}

export interface ToolTestResult {
  result: { success: boolean; data?: any; error?: string };
}

export interface EntityTestResult {
  formatted: string;
  variables: Record<string, string>;
}

export interface PromptPreviewResult {
  sections: { id: string; text: string; hash: string }[];
  fullText: string;
}

export class PromptTestAPI {
  static async previewPrompt(
    orgId: number,
    userId: number,
    slug: string,
    channel?: BotPromptChannel,
    locationId?: number
  ): Promise<PromptPreviewResult> {
    return APIService.Bot.post<PromptPreviewResult>("/prompt-test/preview", {
      orgId,
      userId,
      slug,
      channel: channel || "voice",
      locationId
    });
  }

  static async testLLM(
    orgId: number,
    userId: number,
    slug: string,
    channel?: BotPromptChannel,
    userMessage?: string,
    locationId?: number
  ): Promise<LLMTestResult> {
    return APIService.Bot.post<LLMTestResult>("/prompt-test/llm", {
      orgId,
      userId,
      slug,
      channel: channel || "voice",
      userMessage,
      locationId
    });
  }

  static async testTool(
    orgId: number,
    userId: number,
    toolName: string,
    input: Record<string, any>,
    channel?: BotPromptChannel,
    locationId?: number
  ): Promise<ToolTestResult> {
    return APIService.Bot.post<ToolTestResult>("/prompt-test/tool", {
      orgId,
      userId,
      toolName,
      input,
      channel: channel || "voice",
      locationId
    });
  }

  static async testEntity(
    orgId: number,
    entityType: string,
    variant: string,
    entityId: number,
    channel?: BotPromptChannel,
    locationId?: number
  ): Promise<EntityTestResult> {
    return APIService.Bot.post<EntityTestResult>("/prompt-test/entity", {
      orgId,
      entityType,
      variant,
      entityId,
      channel: channel || "voice",
      locationId
    });
  }
}
